import { api } from 'API';
import { addImposterToUrl } from 'Utils';
const baseUrl = '/consumEquip';

export interface IEquipmentSingleOrder {
  itemCatalogNumber: number;
  itemName: string;
  quantity: number;
  itemNote: string;
  quantityNote?: string;
  maxAVGQuantityPerMonth?: number;
  lastOrderOfThatItem?: Date;
  isSupplied?: boolean;
  isActive?: boolean;
}

export interface IEquipmentPrevOrder {
  internetRequestNumber?: number;
  caseNumber: string;
  requestNumber?: string;
  note?: string;
  startDate: Date;
  endDate: Date;
  currentStatus: number;
  currentStatusLabel: string;
  createDateAtShemeshSystem?: Date;
  createDate: Date;
  receiveBySupplierDate?: Date;
  orderItemsCount?: number;
  orderItems: IEquipmentSingleOrder[];
  statuses: IEquipmentPrevOrderStatus[];
  adminIsrId?: string;
}

export interface IEquipmentPrevOrderStatus {
  mainStatus: number;
  mainStatusDate?: Date;
  mainStatusLabel?: string;
  subStatusDescription?: string;
}

export interface ILastOrderId {
  internetRequestNumber: number;
}

export enum ConsEquipOrderIdentifierType {
  IntReqNumber = 1,
  ShemeshRequestNumber = 2,
}

export const getEquipment = async () => {
  const equipmentData = await api.get<IEquipmentPrevOrder[]>(
    addImposterToUrl(`${baseUrl}/v2`, true)
  );
  if (equipmentData.data) {
    return equipmentData.data;
  }
};

export const getEquipmentByID = async (
  id: string | undefined,
  type: number
) => {
  const equipmentData = await api.get<IEquipmentPrevOrder>(
    addImposterToUrl(`${baseUrl}/${id}?identifierType=${type}`, false)
  );
  if (equipmentData.data) {
    return equipmentData.data;
  }
};

export const getLastOrderId = async () => {
  const lastOrderId = await api.get<ILastOrderId>(
    addImposterToUrl(`${baseUrl}/lastIntReqNumber`, true)
  );

  return lastOrderId?.data?.internetRequestNumber || null;
};
